/** ======================== */
/** =      School Key      = */
/** ======================== */
/** 학교 목록 조회 */
export const GET_SCHOOLS = "GET_SCHOOLS";

/** ======================= */
/** =       User Key      = */
/** ======================= */
/** 유저 정보 조회 */
export const GET_USER_INFO = "GET_USER_INFO ";

/** 학생 정보 조회 */
export const GET_STUDENT = "GET_STUDENT";

/** 법정보호자 정보 조회 */
export const GET_GUARDIAN = "GET_GUARDIAN";

/** 나의 운동 참여 현황 정보 조회 */
export const GET_EXERCISE_INFO = "GET_EXERCISE_INFO";

/** 운동 가능 여부 조회 */
export const GET_EXERCISE_AVAILABILITY = "GET_EXERCISE_AVAILABILITY";

/** ======================== */
/** =      Health Key      = */
/** ======================== */
/** 나의 건강 정보*/
export const GET_HEALTH_INFO = "GET_HEALTH_INFO";

/** 홈 내 건강 요약 */
export const GET_STUDENT_HEALTH_SUMMARY = "GET_STUDENT_HEALTH_SUMMARY";

/** 카테고리별 영상 목록 조회 */
export const GET_VIDEOS_BY_CATEGORY = "GET_VIDEOS_BY_CATEGORY";

/** ======================== */
/** =      Option Key      = */
/** ======================== */
/** 새로운 알람 조회(이벤트 및 공지 OR 알람) */
export const GET_COUNT_ALARM = "GET_COUNT_ALARM";

/** 공지사항/이벤트 목록 조회 */
export const GET_NOTICE = "GET_NOTICE";

/** 공지사항/이벤트 목록 조회 */
export const GET_PUSH_ALARM = "GET_PUSH_ALARM";

/** 공지사항/이벤트 세부 내용 조회 */
export const GET_DETAIL_NOTICE = "GET_DETAIL_NOTICE";

/** 응원 메시지 목록 조회 */
export const GET_CHEER_MESSAGES = "GET_CHEER_MESSAGES";

/** 안 읽은 메시지 존재 여부 조회 */
export const GET_UNREAD_MESSAGE = "GET_UNREAD_MESSAGE";

/** 포인트 히스토리 */
export const GET_POINT_HISTORY = "GET_POINT_HISTORY";

/** 1:1문의 정보 조회 */
export const GET_CONTACT = "GET_CONTACT";

/** 1:1문의 답변 조회 */
export const GET_COMMENT = "GET_COMMENT";

/** 카테고리별 자주 묻는 질문 목록 조회 */
export const GET_FAQS_BY_CATEGORY = "GET_FAQS_BY_CATEGORY";

/** 특정 학생 연속 출석 일수 조회 */
export const GET_CONTINUOUS_ATTENDANCE = "GET_CONTINUOUS_ATTENDANCE";
